/**
 * PRJ1417943 - Integration Accelerator
 * Dynamically builds agencyData from agencies config
 * Changed from static export to getAgencyData() function to prevent circular dependencies
 * and enable lazy loading with null-checking
 */

// Agencies config
import agencies from '../../../agency-config/agencies';

// Synchronously build agencySlugMap from agencies.json
export const agencySlugMap = (() => {
  const map = {};
  const agenciesArr = Array.isArray(agencies) ? agencies : Object.values(agencies);
  agenciesArr.forEach(({ agency }) => {
    if (agency) {
      const { agencyCode, agencyShortName, applicationCodes } = agency;
      const slug = String(agencyShortName || '').toLowerCase();
      map[agencyCode] = { slug, ...applicationCodes };
    }
  });
  return map;
})();

// Synchronously build agencyData using require (no Promise/await)
export function getAgencyData() {
  const agencySlugMapLocal = {};
  const agencyData = {};
  const agenciesArr = Array.isArray(agencies) ? agencies : Object.values(agencies);
  agenciesArr.forEach(({ agency }) => {
    if (agency) {
      const { agencyCode, agencyShortName, applicationCodes, importPath } = agency;
      const slug = String(agencyShortName || '').toLowerCase();
      agencySlugMapLocal[agencyCode] = { slug, ...applicationCodes };
      if (importPath) {
        try {
          // Use require for synchronous import
          // eslint-disable-next-line global-require, import/no-dynamic-require
          const mod = require(`./${importPath.replace('./', '')}`);
          Object.assign(agencyData, mod);
        } catch (e) {
          // Optionally log or handle missing module
        }
      } else {
        agencyData[slug] = agency;
      }
    }
  });
  return { agencySlugMap: agencySlugMapLocal, agencyData };
}

// Export function to get agency slug by app slug - uses existing agencySlugMap
export const getAgencySlugByAppSlug = (renewalSlug) => {
  const agency = Object.values(agencySlugMap).find((agency) =>
    Object.values(agency).includes(renewalSlug)
  );
  return agency ? agency.slug : null;
};

// Export appSlugs array - extract from existing agencySlugMap
export const appSlugs = (() => {
  const slugs = [];
  Object.values(agencySlugMap).forEach((agency) => {
    Object.entries(agency).forEach(([key, value]) => {
      if (key !== 'slug' && !slugs.includes(value)) {
        slugs.push(value);
      }
    });
  });
  return slugs;
})();
